export default {
  text_one: 'Earn {{count}} point',
  text_other: 'Earn {{count}} points',
};